import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Modal } from '@/shared/components/Modal';
import { Input } from '@/shared/components/Input';
import { Button } from '@/shared/components/Button';
export function NewFolderModal({ open, parentLabel, onClose, onSubmit, loading, error, }) {
    const [value, setValue] = useState('');
    useEffect(() => {
        if (open)
            setValue('');
    }, [open]);
    function handleSubmit(e) {
        e.preventDefault();
        const trimmed = value.trim();
        if (!trimmed)
            return;
        onSubmit(trimmed);
    }
    return (_jsx(Modal, { open: open, onClose: onClose, title: "Nueva carpeta", size: "sm", children: _jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col gap-4", children: [_jsxs("p", { className: "text-sm", style: { color: 'var(--fg-2)' }, children: ["Se crear\u00E1 dentro de ", _jsx("strong", { style: { color: 'var(--fg)' }, children: parentLabel }), "."] }), _jsx(Input, { label: "Nombre de la carpeta", placeholder: "Ej. Tema 1 \u2014 Constituci\u00F3n", autoFocus: true, value: value, onChange: (e) => setValue(e.target.value), ...(error ? { error } : {}) }), _jsxs("div", { className: "flex justify-end gap-2", children: [_jsx(Button, { variant: "secondary", type: "button", onClick: onClose, children: "Cancelar" }), _jsx(Button, { type: "submit", loading: !!loading, disabled: !value.trim(), children: "Crear" })] })] }) }));
}
//# sourceMappingURL=NewFolderModal.js.map